export const CATCH_UNAUTHORIZED = 'CATCH_UNAUTHORIZED';

export const AUTH_REQUEST = 'REQUEST';
export const AUTH_SUCCESS = 'SUCCESS';
export const AUTH_FAILURE = 'FAILURE';
export const AUTH_LOGOUT = 'LOGOUT';

export const CATALOG_SEARCH_SET = 'SEARCH_SET';
export const CATALOG_REQUEST = 'REQUEST';
export const CATALOG_UPDATE = 'UPDATE';
export const CATALOG_SELECT_VIDEO = 'SELECT_VIDEO';
export const CATALOG_CLEAN = 'CLEAN';
export const CATALOG_SELECTED_SET = 'SELECTED_SET';
export const CATALOG_DELETE = 'DELETE';
export const CATALOG_ADD = 'ADD';
export const CATALOG_SORT_SET = 'SORT_SET';
export const CATALOG_FILTERS_SET = 'FILTERS_SET';
export const CATALOG_FILTERS_ADD = 'FILTERS_ADD';
export const CATALOG_FILTERS_REMOVE = 'FILTERS_REMOVE';
export const CATALOG_FILTERS_EDIT = 'FILTERS_EDIT';

export const FOLDERS_REQUEST = 'FOLDERS_REQUEST';
export const FOLDERS_SET = 'FOLDERS_SET';
export const FOLDERS_ADD = 'FOLDERS_ADD';
export const FOLDERS_UPDATE = 'FOLDERS_UPDATE';
export const FOLDERS_EDIT = 'FOLDERS_EDIT';
export const FOLDERS_REMOVE = 'FOLDERS_REMOVE';
export const FOLDERS_SELECT_ALL = 'FOLDERS_SELECT_ALL';
export const FOLDERS_SELECT = 'FOLDERS_SELECT';
export const FOLDERS_SORTED_SET = 'FOLDERS_SORTED_SET';
export const FOLDERS_VIDEO_COPY = 'FOLDERS_VIDEO_COPY';
export const FOLDERS_VIDEO_REMOVE = 'FOLDERS_VIDEO_REMOVE';
export const FOLDERS_CLEAN = 'FOLDERS_CLEAN';

export const PROFILE_REQUEST = 'REQUEST';
export const PROFILE_UPDATE = 'UPDATE';
export const PROFILE_CLEAN = 'CLEAN';

export const ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST';
export const ACCOUNTS_UPDATE = 'ACCOUNTS_UPDATE';
export const ACCOUNT_SET = 'ACCOUNT_SET';

export const CHARTS_CLEAN = 'CLEAN';
export const CHARTS_ACCOUNT_REQUEST = 'ACCOUNT_REQUEST';
export const CHARTS_AMOUNT_REQUEST = 'AMOUNT_REQUEST';
export const CHARTS_VIDEO_REQUEST = 'VIDEO_REQUEST';
export const CHARTS_ACCOUNT_SET = 'ACCOUNT_SET';
export const CHARTS_AMOUNT_SET = 'AMOUNT_SET';
export const CHARTS_VIDEO_SET = 'VIDEO_SET';
export const CHARTS_ACCOUNT_CLEAN = 'ACCOUNT_CLEAN';
export const CHARTS_AMOUNT_CLEAN = 'AMOUNT_CLEAN';
export const CHARTS_VIDEO_CLEAN = 'VIDEO_CLEAN';

export const VIDEO_DETAILS_REQUEST = 'DETAILS_REQUEST';
export const VIDEO_DETAILS_SET = 'DETAILS_SET';
export const VIDEO_DETAILS_FILURE = 'DETAILS_FILURE';
export const VIDEO_DETAILS_SUCCESS = 'DETAILS_SUCCESS';
export const VIDEO_CLIPS_REQUEST = 'CLIPS_REQUEST';
export const VIDEO_CLIPS_SET = 'CLIPS_SET';
export const VIDEO_SHOTS_REQUEST = 'SHOTS_REQUEST';
export const VIDEO_SHOTS_SET = 'SHOTS_SET';
export const VIDEO_CHARTS_REQUEST = 'CHARTS_REQUEST';
export const VIDEO_CHARTS_SET = 'CHARTS_SET';
export const VIDEO_CLEAN = 'CLEAN';
export const VIDEO_TAB_SET = 'TAB_SET';
